/** `/$org/apps/contract-intelligence/reviews/`: every review, by status. */
import { createFileRoute } from "@tanstack/react-router";

import { CiReviewsPage } from "../components/apps/contractIntelligence/CiReviewsPage";

export const Route = createFileRoute("/$org/apps/contract-intelligence/reviews/")({
  component: CiReviewsPage,
});
